import { takeEvery, put, call } from 'redux-saga/effects';
import { GET_BATTLEFIELD, GET_SPEC_BATTLEFIELD } from './actionTypes';
import {
  getBattlefieldSuccess,
  getMyBattlefieldSuccess,
  getBattlefieldFail,
  getSpecBattlefieldSuccess,
  getSpecBattlefieldFail,
  showLoading,
  hideLoading
} from './actions';
import { getBattlefieldInfo, getSpecBattle } from '../../helpers/backend_helper';

/* NOT SOCKET CONNECTION START */
function* fetchBattlefieldInfo({ payload: id }) {
  try {
    yield put(showLoading(true))
    const response = yield call(getBattlefieldInfo, id)
    if(id._id === 'all'){
      yield put(getBattlefieldSuccess(response))
    } else {
      yield put(getMyBattlefieldSuccess(response))
    }
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(getBattlefieldFail(error))
  }
}
function* getSpecBattles({ payload: id }) {
  try {
    yield put(showLoading(true));
    const response = yield call(getSpecBattle, id);
    yield put(getSpecBattlefieldSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(getSpecBattlefieldFail(error));
  }
}
/* NOT SOCKET CONNECTION END */

/* LIVE SOCKET CONNECTION END */
function* battleSaga() {
  yield takeEvery(GET_BATTLEFIELD, fetchBattlefieldInfo);
  yield takeEvery(GET_SPEC_BATTLEFIELD, getSpecBattles);
}

export default battleSaga;
